import { API_URL } from "config";
import Http from "util/https";
import { FetchWarehousesRequest, FetchWarehousesResponse, WarehouseInfo } from "../types/index";

/**
 * 仕入先倉庫・倉庫一覧取得Api
 * @param params 倉庫一覧Apiのパラメータ
 * @returns 倉庫情報のリスト
 */
export async function warehouseListApi(
  params: FetchWarehousesRequest,
): Promise<FetchWarehousesResponse> {
  // console.log("送信する倉庫タイプ:", params);

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/vendor/depot/select`;
  const res = await http.post<FetchWarehousesResponse>(url, params);

  console.log("取得した倉庫情報:", res.data);
  res.data.depot_infos = res.data.depot_infos.map(di => {
    if("depot_type" in di && di.depot_type != null) {
      // eslint-disable-next-line no-param-reassign
      di.depot_kind = di.depot_type;
      // eslint-disable-next-line no-param-reassign
      delete di.depot_type
    }
    return di;
  });
  console.log("変更後の倉庫情報:", res.data)
  return res.data; // データ全体を返す
}

/**
 * 仕入先倉庫の更新API
 * @param warehouse 倉庫情報の更新パラメータ
 * @returns 更新された倉庫情報
 */
export async function updateWarehouseApi(warehouse: {
  depot_kind: number;
  operation: number;
  depot_cd?: string;
  depot_name?: string;
  pref_infos?: Array<{ pref_cd: string; pref_name: string }>;
}): Promise<WarehouseInfo> {
  // console.log("送信する更新データ:", warehouse);

  // 認証情報を含むHTTPクライアントを作成
  const http = Http.default.alterAuth({ useToken: true });
  // APIのURLを指定
  const url = `${API_URL}/vendor/depot/update`;
  // APIに対してPOSTリクエストを行う
  const res = await http.post<WarehouseInfo>(url, warehouse);

  // console.log("更新した際に返ってくるデータ:", res.data);
  return res.data;
}
